export default __webpack_public_path__ + "static/main-video-poster-mobile-dc2c14bf1d48bd317f74b1e46efc4a23.webp";